export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyBfAAq4nTtJAr6xiqhKKqg1BZgPy3y7JJQ',
    authDomain: 'biletlingo-1552410617703.firebaseapp.com',
    databaseURL: 'https://biletlingo-1552410617703.firebaseio.com',
    projectId: 'biletlingo-1552410617703',
    storageBucket: 'biletlingo-1552410617703.appspot.com',
    messagingSenderId: '402748764022',
    appId: '1:402748764022:web:7467219a2ceb9625131457',
  },
};
